import apiClient from '../utils/apiClient';

export interface DataProvider {
    id: number;
    name: string;
    inputContainerName?: string;
}

export const getDataProviders = async (): Promise<DataProvider[]> => {
    return apiClient.get<DataProvider[]>('api/DataProviders');
};

export const getDataProviderById = async (id: number): Promise<DataProvider> => {
    return apiClient.get<DataProvider>(`api/DataProviders/${id}`);
};
